export const BOUNDARY_FILL_IMAGE = 'boundaryFill';

export const BOUNDARY_FILL_IMAGE_PIXEL_RATIO = 7;

export const NO_ENTRY_FILL_IMAGE = 'noEntryFill';

export const NO_ENTRY_FILL_IMAGE_PIXEL_RATIO = 15;
